import React from "react";
import { StyleSheet, View } from "react-native";
import { Text } from "react-native-paper";
import { DisplayTextRow } from "../DisplayTextRow";
import { ValueDisplay } from "../../ValueDisplay";
import { FieldDisplayRendererProps } from "./types";

export const SimpleValueDisplayRenderer = ({
  field,
  value,
  t,
  valueStyle,
}: FieldDisplayRendererProps) => {
  if (field.type === "phone") {
    return <ValueDisplay field={field} value={value} style={valueStyle} />;
  }

  if (field.hideLabel) {
    return <ValueDisplay field={field} value={value} style={valueStyle} />;
  }

  if (field.valueDisplayMode === "stacked") {
    const isEmpty =
      value === null ||
      value === undefined ||
      (typeof value === "string" && value.trim().length === 0);

    if (field.hideWhenEmpty !== false && isEmpty) {
      return null;
    }

    return (
      <View style={styles.stackedContainer}>
        <Text style={styles.stackedLabel}>{t(field.label)}</Text>
        <ValueDisplay field={field} value={value} style={valueStyle} />
      </View>
    );
  }

  if (field.valueDisplayMode === "bubble") {
    const isEmptyComment =
      value === null ||
      value === undefined ||
      (typeof value === "string" && value.trim().length === 0);

    if (field.hideWhenEmpty !== false && isEmptyComment) {
      return null;
    }

    return (
      <View style={styles.commentContainer}>
        <Text style={styles.commentLabel}>{t(field.label)}:</Text>
        <View
          style={
            field.valueDisplayTone === "danger"
              ? styles.reasonCommentBubble
              : styles.commentBubble
          }
        >
          <ValueDisplay
            field={field}
            value={value}
            style={StyleSheet.flatten([styles.commentText, valueStyle])}
          />
        </View>
      </View>
    );
  }

  return (
    <DisplayTextRow label={t(field.label)}>
      <ValueDisplay field={field} value={value} style={valueStyle} />
    </DisplayTextRow>
  );
};

const styles = StyleSheet.create({
  commentContainer: {
    gap: 6,
  },
  commentLabel: {
    color: "#555555",
  },
  commentBubble: {
    backgroundColor: "#f3f4f6",
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "#e5e7eb",
    paddingHorizontal: 10,
    paddingVertical: 8,
  },
  reasonCommentBubble: {
    backgroundColor: "#fdecec",
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "#ef9a9a",
    paddingHorizontal: 10,
    paddingVertical: 8,
  },
  commentText: {
    color: "#374151",
  },
  stackedContainer: {
    gap: 4,
  },
  stackedLabel: {
    fontWeight: "bold",
    marginTop: 8,
    marginBottom: 4,
  },
});
